<div>
  @if (!isLoaded) {
    <busy-indicator big="true"></busy-indicator>
  }

  @if (isLoaded) {
    <div>
      @for (cardData of details; track cardData) {
        <div class="contentRow">
          <mat-divider></mat-divider>
          <div fxFlex>
            @if (cardData.Title) {
              <span [ngClass]="colorClass">{{cardData.Title}}</span>
            }
            @if (cardData.SubHeader) {
              <span [ngClass]="colorClass">{{cardData.SubHeader}} &bull; </span>
            }
            @if (cardData.Description) {
              <span [ngClass]="colorClass"> {{cardData.Description}}</span>
            }
            <div fxLayout="row" layout-wrap>
              @for (dataElement of getVisibleDataElements(cardData); track dataElement) {
                <div fxFlex>
                  <labeled-field [label]="dataElement.Label">
                    <truncate-text [mainText]="dataElement.Value">
                    </truncate-text>
                  </labeled-field>
                </div>
              }
            </div>
            <br>
              <table class="full-table">
                @for (dataElement of getVisibleHeaderElements(cardData); track dataElement; let i = $index) {
                  <tr>
                    @for (data of getLabelParts(dataElement); track data) {
                      <td [ngStyle]="getHeaderAlignStyle(i)">
                        {{data}}
                      </td>
                    }
                  </tr>
                }
                @for (dataElement of getVisibleRowElements(cardData); track dataElement) {
                  <tr>
                    @for (data of getValueParts(dataElement); track data) {
                      <td [ngStyle]="getDataAlignStyle(data)">
                        <truncate-text [mainText]="data">
                        </truncate-text>
                      </td>
                    }
                  </tr>
                }
              </table>
            </div>
            <mat-divider></mat-divider>
          </div>
        }
      </div>
    }
  </div>